module.exports = __webpack_public_path__ + "static/img/Bachelor_010157.a8b68d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010157.jpg
// module id = 117
// module chunks = 0